
<template>
  <!-- Campaign Analytics Card -->
  <b-card body-class="p-4" class="mt-3">
    <!-- Campaign Title and Color -->
    <div class="d-flex justify-content-between">
      <div class="d-flex justify-content-start">
        <h3 class="ml-3">{{ item.title }}</h3>
      </div>
    </div>
    <!-- Overall Stats Section -->
    <div class="my-3 pt-2">
      <b-row>
        <b-col cols="12" md="6">
          <b-card title="Stats">
            <campaign-history-stats-block :stats="stats" />
          </b-card>
        </b-col>
        <b-col cols="12" md="6">
          <b-card :title="`History (${historyItems.total || 0})`">
            <campaign-history-block
              :historyItems="historyItems.entries"
            />
            <div class="d-flex justify-content-center align-items-middle p-3">
              <b-pagination v-model="campaignHistoryPage" :total-rows="historyItems.total || 0" :per-page="campaignHistoryLimit" />
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <!-- Jobs and content share section -->
    <div class="my-3 pt-2">
      <b-row v-if="jobs.length || contentShares.length">
        <b-col v-if="jobs.length" cols="12" md="6">
          <b-card title="Jobs">
            <b-table striped hover :items="jobs"></b-table>
          </b-card>
        </b-col>
        <b-col v-if="contentShares.length" cols="12" md="6">
          <b-card title="Content Shares">
            <b-table striped hover :items="contentShares"></b-table>
            <!-- div class="d-flex justify-content-center align-items-middle p-3">
              <b-pagination v-model="campaignHistoryPage" :total-rows="historyItems.total || 0" :per-page="campaignHistoryLimit" />
            </div -->
          </b-card>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import StatsBlock from '@/components/campaign-admin/StatsBlock.vue';
import ComponentStats from '@/components/campaign-admin/ComponentStats.vue';
import CampaignHistoryBlock from '@/components/campaign-admin/CampaignHistoryBlock.vue';
import CampaignHistoryStatsBlock from '@/components/campaign-admin/CampaignHistoryStatsBlock.vue';
import CampaignAnalyticsQuery from '@/graphql/queries/CampaignAnalytics.gql';

export default {
  components: {
    StatsBlock,
    ComponentStats,
    CampaignHistoryBlock,
    CampaignHistoryStatsBlock
  },
  data: () => ({
    selectedCampaignID: null,
    campaignAnalyticsWhereUser: null,
    campaignAnalyticsWhereJob: null,
    campaign: null,
    campaignHistoryLimit: 5,
    campaignHistoryPage: 1
  }),
  props: {
    campaign: {
      type: Object,
      default: null,
    },
    item: {
      type: Object,
      default: null,
    },
  },
  apollo: {
    api: {
      query: CampaignAnalyticsQuery,
      variables() {
        const { campaign, item, campaignHistoryLimit, campaignHistoryPage } = this;
        const where = {};
        if (item.type === 'USER') {
          where.users = { id: item.id };
        }
        if (item.type === 'JOB') {
          where.jobs = { id: item.id };
        }
        if (item.type === 'CONTENT_SHARE') {
          where.contentShares = { id: item.id };
        }
        return {
          campaignWhere: { id: campaign.id },
          ...(Object.keys(where).length ? { campaignHistoryWhere: where } : {}),
          campaignHistoryLimit,
          campaignHistoryPage
        };
      },
      update({ company }) {
        const { campaign } = company;
        return campaign;
      },
      error(err) {
        this.$notifyFatalErr(err, { prepend: 'Failed to load the campaign analytics' });
      },
      skip() {
        return !this.campaign || !this.item;
      },
      errorPolicy: 'all',
      fetchPolicy: 'network-only',
    },
  },
  computed: {
    historyItems() {
      const { api } = this;
      const { history } = api || {};
      const { historyItems } = history || {};
      const { entries, total } = historyItems || {};
      console.log({ entries, total });
      return {
        entries: Array.isArray(entries) ? entries : [],
        total,
      };
    },
    stats() {
      const { api } = this;
      const { history } = api || {};
      const { stats } = history || {};
      console.log({ stats });
      return stats;
    },
    jobs() {
      const { api } = this;
      const { history } = api || {};
      const { jobs } = history || {};
      console.log({ jobs });
      return jobs
        .map(({ job, count, points }) => ({ title: (job || {}).title, count, points }))
        .sort((a, b) => b.count - a.count);
    },
    contentShares() {
      const { api } = this;
      const { history } = api || {};
      const { contentShares } = history || {};
      console.log({ contentShares });
      return contentShares
        .map(({ contentShare, count, points }) => ({ title: (contentShare || {}).title, count, points }))
        .sort((a, b) => b.count - a.count);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/campaign-admin/CampaignAnalyticsItemProfile.vue